import React, { useState } from "react";
import { Box, Link } from "@mui/material";
import ProductImageGalleryModal from "../../modals/product-image-gallery/ProductImageGalleryModal";

const thumbnailSx = {
  flexShrink: 0,
  width: 40,
  height: 40,
  borderRadius: "6px",
  overflow: "hidden",
  border: "1px solid #d0e4f7",
  cursor: "pointer",
  boxShadow: "0 1px 4px rgba(11,101,181,0.1)",
  "&:hover": {
    boxShadow: "0 2px 8px rgba(11,101,181,0.2)",
  },
};

export default function ProductImageThumbnails({
  images = [],
  productName = "",
  productId,
  recordList,
  intakeScope = "admin",
}) {
  const [galleryOpen, setGalleryOpen] = useState(false);
  const validImages = images.filter((url) => typeof url === "string" && url.trim());

  if (validImages.length === 0) {
    return "-";
  }

  const visibleImages = validImages.slice(0, 2);
  const remainingCount = validImages.length - 2;

  const openGallery = (e) => {
    e.stopPropagation();
    setGalleryOpen(true);
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, minWidth: 90 }}>
        {visibleImages.map((url, index) => (
          <Box key={`${url}-${index}`} sx={thumbnailSx} onClick={openGallery}>
            <Box
              component="img"
              src={url}
              alt={`Product ${index + 1}`}
              loading="lazy"
              sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            />
          </Box>
        ))}
        {remainingCount > 0 && (
          <Link
            component="button"
            underline="none"
            color="primary"
            onClick={openGallery}
            sx={{ fontSize: 12, fontWeight: 600, whiteSpace: "nowrap" }}
          >
            +{remainingCount} More
          </Link>
        )}
      </Box>

      <ProductImageGalleryModal
        open={galleryOpen}
        handleClose={() => setGalleryOpen(false)}
        images={validImages}
        productName={productName}
        productId={productId}
        recordList={recordList}
        intakeScope={intakeScope}
      />
    </>
  );
}
